define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Dimension = (function () {
        function Dimension() {
            this.Width = 0;
            this.Height = 0;
        }
        return Dimension;
    }());
    exports.Dimension = Dimension;
});
//# sourceMappingURL=Dimension.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Configuration/Dimension.js
// module id = 150
// module chunks = 0